import { AxiosError, AxiosResponse } from "axios";
import Core from "../core";

async function swapShift(payload: any) {
  const api = Core.getInstance().api();
  const data = await api.put(`/v1/swapShift`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function getAllShifts(
  empId: number,
  page: number,
  fromDate: string,
  toDate: string
) {
  const api = Core.getInstance().api();
  const data = await api.get(
    `/v1/employee/getShiftRoaster?emp_id=${empId}&locale=${localStorage.getItem(
      "emplang"
    )}&page=${page}&from_date=${fromDate}&to_date=${toDate}`
  );
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

async function cancelSwap(payload: any) {
  const api = Core.getInstance().api();
  const data = await api.put(`/v1/roaster/cancel`, payload);
  if (data instanceof AxiosError) {
    return data.response;
  }

  const response = data.data;
  return response;
}

export const shiftAndScheduleService = {
  getAllShifts,
  swapShift,
  cancelSwap,
};
